var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockClosed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 15.6666C5.14924 15.6666 5 15.8159 5 16V28C5 28.1841 5.14924 28.3333 5.33333 28.3333H26.6667C26.8508 28.3333 27 28.1841 27 28V16C27 15.8159 26.8508 15.6666 26.6667 15.6666H5.33333ZM3 16C3 14.7113 4.04467 13.6666 5.33333 13.6666H26.6667C27.9553 13.6666 29 14.7113 29 16V28C29 29.2886 27.9553 30.3333 26.6667 30.3333H5.33333C4.04467 30.3333 3 29.2886 3 28V16Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.66663C12.8704 3.66663 10.3333 6.20368 10.3333 9.33329V14.6666C10.3333 15.2189 9.88562 15.6666 9.33333 15.6666C8.78105 15.6666 8.33333 15.2189 8.33333 14.6666V9.33329C8.33333 5.0991 11.7659 1.66663 16 1.66663C20.2341 1.66663 23.6667 5.0991 23.6667 9.33329V14.6666C23.6667 15.2189 23.219 15.6666 22.6667 15.6666C22.1144 15.6666 21.6667 15.2189 21.6667 14.6666V9.33329C21.6667 6.20368 19.1296 3.66663 16 3.66663Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16.5523 19 17 19.4477 17 20V24C17 24.5522 16.5523 25 16 25C15.4477 25 15 24.5522 15 24V20C15 19.4477 15.4477 19 16 19Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock-closed.63d4878c.svg";
export { ForwardRef as ReactComponent };